import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ContentRow from '../components/ContentRow';
import Footer from '../components/Footer';
import { setupHoverVideoHandlers } from '../utils/videoHandler';
import { useIsMobile } from '../hooks/use-mobile';
import { Dialog, DialogContent } from '@/components/ui/dialog.tsx';
import VideoPreloader from '../components/VideoPreloader';

const Index = () => {
  const isMobile = useIsMobile();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [previewEmbedId, setPreviewEmbedId] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    setupHoverVideoHandlers();
  }, []);

  const handleToggleVideo = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.muted = false;
        videoRef.current.volume = 1.0;
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  // IDs únicos por item (corrigido)
  const exclusivosItems = [
    { id: 'exclusivo-1', title: 'Exclusivo: A Mesma Mentira', imageSrc: '/img/A_Mesma_Mentira.png', embedId: '3644a684f98ea8fe223c713b77189a77', videoSrc: '/videos/A_Mesma_Mentira.mp4', price: 7 },
    { id: 'exclusivo-2', title: 'Exclusivo: Frente Fria', imageSrc: '/img/Frente_Fria.png', embedId: '757b505cfd34c64c85ca5b5690ee5293', videoSrc: '/videos/Frente_Fria.mp4', price: 7 },
  ];

  const ultimosVistosItems = [
    { id: 'ult-1', title: 'Zezé Di Camargo|Rustico-Cuiabá', imageSrc: '/img/show_em_cuiaba.png', embedId: 'a597e50502f5ff68e3e25b9114205d4a', videoSrc: '/videos/show_em_cuiaba.mp4'},
    { id: 'ult-2', title: 'Navio do Zezé', imageSrc: '/img/navio-do-zezé.png', embedId: '6c4b761a28b734fe93831e3fb400ce87', videoSrc: '/videos/navio_zeze.mp4'},
    { id: 'ult-3', title: 'Victor e Leo | Irmãos', imageSrc: '/img/Victor_e_Leo.jpg', embedId: '0777d5c17d4066b82ab86dff8a46af6f', videoSrc: '/videos/victor_e_leo.mp4'},
    { id: 'ult-4', title: 'Oa Amigos', imageSrc: '/img/os_amigos.png', embedId: '006f52e9102a8d3be2fe5614f42ba989', videoSrc: '/videos/os_amigos.mp4'},
    { id: 'ult-5', title: 'Fazenda é o Amor', imageSrc: '/img/fazenda-é-o-amor.jpg', embedId: '6c4b761a28b734fe93831e3fb400ce87', videoSrc: '/videos/fazenda_e_o_amor.mp4'},
    { id: 'ult-6', title: 'Navio do Zezé', imageSrc: '/img/navio-do-zezé.png', embedId: '9766527f2b5d3e95d4a733fcfb77bd7e', videoSrc: '/videos/navio_zeze.mp4'},
  ];

  const showsItems = [
    { id: 'show-1', title: 'Zezé Di Camargo - Frente Fria', imageSrc: '/img/Frente_Fria.png', embedId: '0aa1883c6411f7873cb83dacb17b0afc', videoSrc: '/videos/Frente_Fria.mp4'},
    { id: 'show-2', title: 'Zezé Di Camargo | Rústico - A Origem', imageSrc: '/img/A_Origem.png', embedId: '58a2fc6ed39fd083f55d4182bf88826d', videoSrc: '/videos/A_Origem.mp4'},
    { id: 'show-3', title: 'Pra não pensar em você', imageSrc: '/img/zeze&luciano.jpg', embedId: '1c9ac0159c94d8d0cbedc973445af2da', videoSrc: '/videos/zeze&luciano.mp4'},
    { id: 'show-4', title: 'Ed. & Hud.- Jaguariuna', imageSrc: '/img/edson_hudson.png', embedId: '2a79ea27c279e471f4d180b08d62b00a', videoSrc: '/videos/Edson_Hudson.mp4', price: 7 },
    { id: 'show-5', title: 'Victor e Leo | Irmãos', imageSrc: '/img/Victor_e_Leo.jpg', embedId: '0777d5c17d4066b82ab86dff8a46af6f', videoSrc: '/videos/victor_e_leo.mp4',},
    { id: 'show-6', title: 'Chitãozinho e Xororó | Turnê 50 anos', imageSrc: '/img/chitaozinho-e-xororo.jpg', embedId: '82aa4b0af34c2313a562076992e50aa3', videoSrc: '/videos/chitaozinho_e_xororo.mp4'},
    { id: 'show-7', title: 'Fern. & Soroc. | Jaguariuna', imageSrc: '/img/fernando_sorocaba.jpeg', embedId: 'b73ce398c39f506af761d2277d853a92', videoSrc: '/videos/fernando_sorocaba.mp4', price: 7 },
  ];

  const filmesItems = [
    { id: 'filme-1', title: '2 Filhos de Francisco', imageSrc: '/img/2_Filhos_de_Francisco.jpg', embedId: '1d7f7abc18fcb43975065399b0d1e48e', videoSrc: '/videos/2_filho_de_franscico.mp4'},
    { id: 'filme-2', title: 'O Menino da Porteira', imageSrc: '/img/menino_da_porteira.jpg', embedId: '140f6969d5213fd0ece03148e62e461e', videoSrc: '/videos/menino_da_porteira.mp4'},
    { id: 'filme-3', title: 'É o Amor', imageSrc: '/img/e_o_amor.jpg', embedId: '3636638817772e42b59d74cff571fbb3', videoSrc: '/videos/e_o_amor.mp4', price: 7 },
    { id: 'filme-4', title: 'Só se for por Amor', imageSrc: '/img/So_se_for_por_Amor.jpg', embedId: '149e9677a5989fd342ae44213df68868', videoSrc: '/videos/so_se_for_por_amor.mp4'},
  ];

  return (
    <div className="bg-[#141414] bg-rustico-dark bg-cover bg-center min-h-screen" style={{ backgroundImage: "url('/img/fundo_layout2.png')" }}>
      <Header />
      <main className="pt-[70px] sm:pt-[80px] md:pt-[90px] p-3 sm:p-4 md:p-5 overflow-visible relative">
        <div className="container mx-auto px-0 max-w-full">
          <div className="flex flex-col md:flex-row mb-10">
            <div className="md:w-1/4 mb-6 md:mb-0 flex items-center justify-center">
              {!isMobile && (
                <div className="w-[200px] sm:w-[300px] md:w-[400px] hidden md:block ml-5 z-10 cursor-pointer" onClick={handleToggleVideo}>
                  {!videoLoaded && (
                    <VideoPreloader videoRef={videoRef} setLoaded={setVideoLoaded} src="/videos/video_zez1.mp4" />
                  )}
                  <video
                    ref={videoRef}
                    src="/videos/video_zez1.mp4"
                    preload="auto"
                    playsInline
                    muted
                    controls={false}
                    className="w-full h-auto"
                    style={{ background: 'black', display: videoLoaded ? 'block' : 'none' }}
                  >
                    Seu navegador não suporta vídeo.
                  </video>
                </div>
              )}
            </div>
            <div className="md:w-3/4">
              <Hero />
            </div>
          </div>

          <div className="w-full">
            <ContentRow title="Vídeos Exclusivos" items={exclusivosItems} category="exclusivos" fullWidth={true} onPreview={setPreviewEmbedId} />
            <ContentRow title="Últimos vistos" items={ultimosVistosItems} category="ultimos-vistos" fullWidth={true} onPreview={setPreviewEmbedId} />
            <ContentRow title="Shows" items={showsItems} category="shows" fullWidth={true} onPreview={setPreviewEmbedId} />
            <ContentRow title="Filmes" items={filmesItems} category="filmes" fullWidth={true} onPreview={setPreviewEmbedId} />
          </div>
        </div>
      </main>
      <Footer />

      {previewEmbedId && (
        <Dialog open={true} onOpenChange={() => setPreviewEmbedId(null)}>
          <DialogContent className="w-full h-[70vh] max-w-5xl bg-black">
            <div className="relative flex items-center w-[240px] mr-2 -ml-6">
              <iframe
                src={`https://embed.rusticoplay.com/${previewEmbedId}`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="absolute top-0 left-0 w-full h-full"
                title="Preview Video"
              />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default Index;
